import { TProjectResponse } from "../../redux/types";
import useNetworkToken from "./useNetworkToken";

const useProjectTokens = (project?: TProjectResponse) => {
  const _tokens = useNetworkToken(project?.tokens);
  return _tokens;
};

export default useProjectTokens;
